import { gql, useApolloClient } from '@apollo/client';

import { CachedHost } from './interfaces';

export const useGetHostDataForSeans = (hostId: number): CachedHost | null => {
  const apolloClient = useApolloClient();

  const host = apolloClient.readQuery<CachedHost>({
    id: apolloClient.cache.identify({
      id: hostId,
      __typename: 'HostOverview',
    }),
    query: gql`
      query hostOverview {
        alias
        group_id

        user {
          uuid
        }

        info {
          shell_version
        }

        client_sessions {
          duration
          elapsed
          finished_at

          seances {
            status
            tariff {
              kind
            }
          }
        }
      }
    `,
  });

  return host;
};
